"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_MODE_FLAG = 1;
exports.COLOR_MODE_FLAG = 2;
exports.GRADIENT_MODE_FLAG = 4;
//# sourceMappingURL=mode.js.map